import { render, staticRenderFns } from "./leads-content.vue?vue&type=template&id=62c024b1&scoped=true"
import script from "./leads-content.vue?vue&type=script&lang=js"
export * from "./leads-content.vue?vue&type=script&lang=js"
import style0 from "./leads-content.vue?vue&type=style&index=0&id=62c024b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c024b1",
  null
  
)

export default component.exports